import type { ComponentMeta } from "@mijalowcode/types";
import { ComponentCategory, PropType } from "@mijalowcode/types";

export const DescriptionsMeta: ComponentMeta = {
  componentName: "Descriptions",
  package: "@mijadesign/web",
  title: "描述列表",
  description: "用于描述对象或列表的详细信息",
  category: ComponentCategory.DATA_DISPLAY,
  icon: "UnorderedListOutlined",
  visibleInComponentPanel: true,
  canHaveChildren: false,
  editorDnd: {
    dropMode: "slot",
    slotConfig: {
      areas: [{ key: "item", label: "描述项内容", requiresKey: true }],
      defaultArea: "item",
      keyOptionsSource: "descriptions.items",
      keyPlaceholder: "请选择目标描述项",
    },
  },
  props: [
    {
      name: "title",
      label: "标题",
      type: PropType.STRING,
      group: "基础",
    },
    {
      name: "extra",
      label: "右上角内容",
      type: PropType.STRING,
      group: "基础",
    },
    {
      name: "column",
      label: "列配置",
      type: PropType.JSON,
      defaultValue: 3,
      description: "支持数字或响应式对象，如 { xs: 1, sm: 2, md: 3 }",
      group: "布局",
    },
    {
      name: "layout",
      label: "布局方向",
      type: PropType.ENUM,
      defaultValue: "horizontal",
      options: [
        { label: "水平", value: "horizontal" },
        { label: "垂直", value: "vertical" },
      ],
      group: "布局",
    },
    {
      name: "bordered",
      label: "边框",
      type: PropType.BOOLEAN,
      defaultValue: false,
      group: "样式",
    },
    {
      name: "colon",
      label: "显示冒号",
      type: PropType.BOOLEAN,
      defaultValue: true,
      group: "样式",
    },
    {
      name: "size",
      label: "尺寸",
      type: PropType.ENUM,
      defaultValue: "large",
      options: [
        { label: "大", value: "large" },
        { label: "中", value: "medium" },
        { label: "小", value: "small" },
      ],
      group: "样式",
    },
    {
      name: "items",
      label: "列表项配置",
      type: PropType.DESCRIPTIONS_ITEMS,
      description: "5.8+ 推荐写法，支持直接配置 item 数组",
      group: "数据",
    },
    {
      name: "classNames",
      label: "语义类名",
      type: PropType.JSON,
      description: "自定义语义节点 className（高级）",
      group: "高级",
    },
    {
      name: "styles",
      label: "语义样式",
      type: PropType.JSON,
      description: "自定义语义节点样式（高级）",
      group: "高级",
    },
  ],
  defaultProps: {
    column: 3,
    bordered: false,
    layout: "horizontal",
    size: "large",
    colon: true,
    items: [{ label: "名称", children: "示例文本" }],
  },
  preview: [
    {
      title: "基础信息",
      props: {
        title: "用户信息",
        items: [
          { label: "姓名", children: "张三" },
          { label: "手机号", children: "13800000000" },
          { label: "状态", children: "启用" },
        ],
      },
    },
    {
      title: "带边框",
      props: {
        title: "订单信息",
        bordered: true,
        column: 2,
        items: [
          { label: "订单号", children: "ORD-20260527001" },
          { label: "金额", children: "1280.00" },
          { label: "收货人", children: "李四" },
          { label: "配送状态", children: "配送中" },
        ],
      },
    },
  ],
  docLinks: [
    {
      title: "Descriptions 文档",
      url: "https://frontend.mishudata.com/uigallery/iframe.html?key=mijadesign-web/components/Descriptions",
      source: "mijadesign",
    },
  ],
  npm: {
    package: "@mijadesign/web",
    exportName: "Descriptions",
  },
  snippet: {
    componentName: "Descriptions",
    package: "@mijadesign/web",
    props: {
      title: "基本信息",
      column: 3,
      bordered: false,
      layout: "horizontal",
      size: "large",
      colon: true,
      items: [{ label: "名称", children: "示例文本" }],
    },
  },
};
